var exports = {
  "kL": "xcc377c0b--1cdbbc--container",
  "kA": "xcc377c0b--1cdbbc--logo-block",
  "wm": "xcc377c0b--1cdbbc--logo",
  "VY": "xcc377c0b--1cdbbc--info-block",
  "nf": "xcc377c0b--1cdbbc--link",
};

module.exports = exports;
